import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  public onError = new EventEmitter<string[]>();
  private _errors: string[] = [];

  set errors(errors: string[]) {
    this._errors = errors;
    if (this.errors) {
      this.onError.emit(this.errors);
    }
  }

  get errors(): string[] {
    return this._errors;
  }

  constructor() { }

}
